var map = {
	"./demos/basic/index.ts": 33865,
	"./demos/children/index.ts": 64883,
	"./demos/circle/index.ts": 6101,
	"./demos/circleSize/index.ts": 41251,
	"./demos/customColor/index.ts": 31428,
	"./demos/innerText/index.ts": 6763,
	"./demos/size/index.ts": 57616,
	"./demos/status/index.ts": 94119
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3116;